import { useEffect, useRef } from "react";
import { useSubscription } from "@trpc/tanstack-react-query";
import { useTRPC } from "../trpc.js";
import { getChatSubscriptionStore } from "../stores/chatSubscriptionStore.js";
/**
 * Starts the tRPC subscription for a styleId and feeds events into the
 * shared ChatSubscriptionStore. Should be called once per styleId
 * in the component tree (typically from the provider).
 */
export function useChatSubscription(styleId) {
    const trpc = useTRPC();
    const storeRef = useRef(getChatSubscriptionStore(styleId));
    useEffect(() => {
        storeRef.current = getChatSubscriptionStore(styleId);
        return () => {
            storeRef.current.clear();
        };
    }, [styleId]);
    useSubscription(trpc.subscribeToStyle.subscriptionOptions({ styleId }, {
        onData: (event) => {
            storeRef.current.handleEvent(event);
        },
        onConnectionStateChange(state) {
            window.logger.info({ state }, "Chat subscription connection state change");
            storeRef.current.setConnectionState(state.state);
        },
        onError: (error) => {
            window.logger.error({ error }, "Error subscribing to chat");
            storeRef.current.setConnectionState("error");
        },
    }));
}
